 	// install a JSONP callback for chunk loading
 	function webpackJsonpCallback(data) {
 		var chunkIds = data[0];
 		var moreModules = data[1];
 		var executeModules = data[2];

 		// add "moreModules" to the modules object,
 		// then flag all "chunkIds" as loaded and fire callback
 		var moduleId, chunkId, i = 0, resolves = [];
 		for(;i < chunkIds.length; i++) {
 			chunkId = chunkIds[i];
 			if(Object.prototype.hasOwnProperty.call(installedChunks, chunkId) && installedChunks[chunkId]) {
 				resolves.push(installedChunks[chunkId][0]);
 			}
 			installedChunks[chunkId] = 0;
 		}
 		for(moduleId in moreModules) {
 			if(Object.prototype.hasOwnProperty.call(moreModules, moduleId)) {
 				modules[moduleId] = moreModules[moduleId];
 			}
 		}
 		if(parentJsonpFunction) parentJsonpFunction(data);

 		while(resolves.length) {
 			resolves.shift()();
 		}

 		// add entry modules from loaded chunk to deferred list
 		deferredModules.push.apply(deferredModules, executeModules || []);

 		// run deferred modules when all chunks ready
 		return checkDeferredModules();
 	};
 	function checkDeferredModules() {
 		var result;
 		for(var i = 0; i < deferredModules.length; i++) {
 			var deferredModule = deferredModules[i];
 			var fulfilled = true;
 			for(var j = 1; j < deferredModule.length; j++) {
 				var depId = deferredModule[j];
 				if(installedChunks[depId] !== 0) fulfilled = false;
 			}
 			if(fulfilled) {
 				deferredModules.splice(i--, 1);
 				result = __webpack_require__(__webpack_require__.s = deferredModule[0]);
 			}
 		}

 		return result;
 	}

 	// The module cache
 	var installedModules = {};

 	// object to store loaded CSS chunks
 	var installedCssChunks = {
 		10: 0
 	};

 	// object to store loaded and loading chunks
 	// undefined = chunk not loaded, null = chunk preloaded/prefetched
 	// Promise = chunk loading, 0 = chunk loaded
 	var installedChunks = {
 		10: 0
 	};

 	var deferredModules = [];

 	// script path function
 	function jsonpScriptSrc(chunkId) {
 		return __webpack_require__.p + "" + ({"0":"styles","1":"commons","2":"5088909434bdac8dfcf8d79d8e9b646309e2c69c","3":"e2daabb3c3e4f6f4aa084bfc911f7255e258eaed","4":"2fb5d6cee164537b6d14f5c4dfa48148b518433e","5":"4d6a44b00a1eeae82bdafe06698b00c4d5cbfe4e","6":"796ed12c150bd44bea2e606e3ba45791219265f7","7":"294b21a2b5b21cf96f4e55fbaa38ff1ddf77acd5","8":"5488bd7f6f29b07e76b72057ec517cd2c584235e","9":"a19d60b2c30ac9484ca94aa410f201cd77ae5191","11":"04300045","13":"component---src-pages-404-tsx","14":"component---src-pages-contact-us-index-tsx","15":"component---src-pages-membership-index-tsx","16":"component---src-pages-reset-password-index-tsx","17":"component---src-templates-about-about-page-tsx","18":"component---src-templates-article-article-details-template-tsx","19":"component---src-templates-article-protected-article-details-template-tsx","20":"component---src-templates-home-home-page-tsx","21":"component---src-templates-industry-industry-page-tsx","22":"component---src-templates-media-media-page-tsx","23":"component---src-templates-programs-and-services-programs-and-services-page-tsx","24":"component---src-templates-project-project-details-template-tsx","25":"component---src-templates-protected-page-tsx","26":"component---src-templates-public-page-tsx","27":"component---src-templates-publication-protected-publication-details-template-tsx","28":"component---src-templates-publication-publication-details-template-tsx","29":"component---src-templates-report-protected-report-details-template-tsx","30":"component---src-templates-report-report-details-template-tsx","31":"component---src-templates-research-and-development-research-and-development-page-tsx","32":"component---src-templates-search-index-tsx","33":"component---src-templates-video-protected-video-details-template-tsx","34":"component---src-templates-video-video-details-template-tsx","35":"component---src-templates-welfare-welfare-page-tsx"}[chunkId]||chunkId) + "-" + {"0":"407fe62976dc5310c43e","1":"750c1052dca8fed25db4","2":"9692820e9ba7a5239956","3":"a7a6fffe9733f2e1109a","4":"fbd3c78f0c9ebcf8d189","5":"70702cc96cc720ce3ee5","6":"d8c33a8904055d06b0d0","7":"d26bf21baa24a704b8c1","8":"db05c489353e3a5f6631","9":"dadc09768ac57264e873","11":"35bf8fd74b647dd2417f","13":"004e11ad7476ffcc2e23","14":"b39f1caeea410325c54e","15":"1869d684596052f37702","16":"af10647c521aebab382d","17":"a4d43b267084fd1f6022","18":"e66e5a662f46af10b3ca","19":"453cfc7f120e3422518a","20":"489bfba85171bfcbd17c","21":"5989caaf0a91fad5c520","22":"cdcee3a9636d4be07a50","23":"ad7b3bb36d50311c19ee","24":"1fc4fd70d315fcd7da8f","25":"fb4faa854bb1f95e1999","26":"47a165a33851655650ef","27":"a924a833d5b2efac39ed","28":"3c649ca8c576206e58bc","29":"9d77dade6c44bc5a54cd","30":"24dc2ab725efd75cdc29","31":"6fe043eee94a3f0f5786","32":"9e2a3936ffa9918d16eb","33":"667a1306a5ba0fc6a35a","34":"ff6e6dbd0bf1b4948d63","35":"7d2cdbd27105533084e4"}[chunkId] + ".js"
 	}

 	// The require function
 	function __webpack_require__(moduleId) {

 		// Check if module is in cache
 		if(installedModules[moduleId]) {
 			return installedModules[moduleId].exports;
 		}
 		// Create a new module (and put it into the cache)
 		var module = installedModules[moduleId] = {
 			i: moduleId,
 			l: false,
 			exports: {}
 		};

 		// Execute the module function
 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);

 		// Flag the module as loaded
 		module.l = true;

 		// Return the exports of the module
 		return module.exports;
 	}

 	// This file contains only the entry chunk.
 	// The chunk loading function for additional chunks
 	__webpack_require__.e = function requireEnsure(chunkId) {
 		var promises = [];


 		// mini-css-extract-plugin CSS loading
 		var cssChunks = {"0":1};
 		if(installedCssChunks[chunkId]) promises.push(installedCssChunks[chunkId]);
 		else if(installedCssChunks[chunkId] !== 0 && cssChunks[chunkId]) {
 			promises.push(installedCssChunks[chunkId] = new Promise(function(resolve, reject) {
 				var href = "" + ({"0":"styles","1":"commons","2":"5088909434bdac8dfcf8d79d8e9b646309e2c69c","3":"e2daabb3c3e4f6f4aa084bfc911f7255e258eaed","4":"2fb5d6cee164537b6d14f5c4dfa48148b518433e","5":"4d6a44b00a1eeae82bdafe06698b00c4d5cbfe4e","6":"796ed12c150bd44bea2e606e3ba45791219265f7","7":"294b21a2b5b21cf96f4e55fbaa38ff1ddf77acd5","8":"5488bd7f6f29b07e76b72057ec517cd2c584235e","9":"a19d60b2c30ac9484ca94aa410f201cd77ae5191","11":"04300045","13":"component---src-pages-404-tsx","14":"component---src-pages-contact-us-index-tsx","15":"component---src-pages-membership-index-tsx","16":"component---src-pages-reset-password-index-tsx","17":"component---src-templates-about-about-page-tsx","18":"component---src-templates-article-article-details-template-tsx","19":"component---src-templates-article-protected-article-details-template-tsx","20":"component---src-templates-home-home-page-tsx","21":"component---src-templates-industry-industry-page-tsx","22":"component---src-templates-media-media-page-tsx","23":"component---src-templates-programs-and-services-programs-and-services-page-tsx","24":"component---src-templates-project-project-details-template-tsx","25":"component---src-templates-protected-page-tsx","26":"component---src-templates-public-page-tsx","27":"component---src-templates-publication-protected-publication-details-template-tsx","28":"component---src-templates-publication-publication-details-template-tsx","29":"component---src-templates-report-protected-report-details-template-tsx","30":"component---src-templates-report-report-details-template-tsx","31":"component---src-templates-research-and-development-research-and-development-page-tsx","32":"component---src-templates-search-index-tsx","33":"component---src-templates-video-protected-video-details-template-tsx","34":"component---src-templates-video-video-details-template-tsx","35":"component---src-templates-welfare-welfare-page-tsx"}[chunkId]||chunkId) + "." + {"0":"c0fb9690ab804be5277d","1":"31d6cfe0d16ae931b73c","2":"31d6cfe0d16ae931b73c","3":"31d6cfe0d16ae931b73c","4":"31d6cfe0d16ae931b73c","5":"31d6cfe0d16ae931b73c","6":"31d6cfe0d16ae931b73c","7":"31d6cfe0d16ae931b73c","8":"31d6cfe0d16ae931b73c","9":"31d6cfe0d16ae931b73c","11":"31d6cfe0d16ae931b73c","13":"31d6cfe0d16ae931b73c","14":"31d6cfe0d16ae931b73c","15":"31d6cfe0d16ae931b73c","16":"31d6cfe0d16ae931b73c","17":"31d6cfe0d16ae931b73c","18":"31d6cfe0d16ae931b73c","19":"31d6cfe0d16ae931b73c","20":"31d6cfe0d16ae931b73c","21":"31d6cfe0d16ae931b73c","22":"31d6cfe0d16ae931b73c","23":"31d6cfe0d16ae931b73c","24":"31d6cfe0d16ae931b73c","25":"31d6cfe0d16ae931b73c","26":"31d6cfe0d16ae931b73c","27":"31d6cfe0d16ae931b73c","28":"31d6cfe0d16ae931b73c","29":"31d6cfe0d16ae931b73c","30":"31d6cfe0d16ae931b73c","31":"31d6cfe0d16ae931b73c","32":"31d6cfe0d16ae931b73c","33":"31d6cfe0d16ae931b73c","34":"31d6cfe0d16ae931b73c","35":"31d6cfe0d16ae931b73c"}[chunkId] + ".css";
 				var fullhref = __webpack_require__.p + href;
 				var existingLinkTags = document.getElementsByTagName("link");
 				for(var i = 0; i < existingLinkTags.length; i++) {
 					var tag = existingLinkTags[i];
 					var dataHref = tag.getAttribute("data-href") || tag.getAttribute("href");
 					if(tag.rel === "stylesheet" && (dataHref === href || dataHref === fullhref)) return resolve();
 				}
 				var existingStyleTags = document.getElementsByTagName("style");
 				for(var i = 0; i < existingStyleTags.length; i++) {
 					var tag = existingStyleTags[i];
 					var dataHref = tag.getAttribute("data-href");
 					if(dataHref === href || dataHref === fullhref) return resolve();
 				}
 				var linkTag = document.createElement("link");
 				linkTag.rel = "stylesheet";
 				linkTag.type = "text/css";
 				linkTag.onload = resolve;
 				linkTag.onerror = function(event) {
 					var request = event && event.target && event.target.src || fullhref;
 					var err = new Error("Loading CSS chunk " + chunkId + " failed.\n(" + request + ")");
 					err.code = "CSS_CHUNK_LOAD_FAILED";
 					err.request = request;
 					delete installedCssChunks[chunkId]
 					linkTag.parentNode.removeChild(linkTag)
 					reject(err);
 				};
 				linkTag.href = fullhref;

 				var head = document.getElementsByTagName("head")[0];
 				head.appendChild(linkTag);
 			}).then(function() {
 				installedCssChunks[chunkId] = 0;
 			}));
 		}

 		// JSONP chunk loading for javascript

 		var installedChunkData = installedChunks[chunkId];
 		if(installedChunkData !== 0) { // 0 means "already installed".

 			// a Promise means "currently loading".
 			if(installedChunkData) {
 				promises.push(installedChunkData[2]);
 			} else {
 				// setup Promise in chunk cache
 				var promise = new Promise(function(resolve, reject) {
 					installedChunkData = installedChunks[chunkId] = [resolve, reject];
 				});
 				promises.push(installedChunkData[2] = promise);

 				// start chunk loading
 				var script = document.createElement('script');
 				var onScriptComplete;

 				script.charset = 'utf-8';
 				script.timeout = 120;
 				if (__webpack_require__.nc) {
 					script.setAttribute("nonce", __webpack_require__.nc);
 				}
 				script.src = jsonpScriptSrc(chunkId);

 				// create error before stack unwound to get useful stacktrace later
 				var error = new Error();
 				onScriptComplete = function (event) {
 					// avoid mem leaks in IE.
 					script.onerror = script.onload = null;
 					clearTimeout(timeout);
 					var chunk = installedChunks[chunkId];
 					if(chunk !== 0) {
 						if(chunk) {
 							var errorType = event && (event.type === 'load' ? 'missing' : event.type);
 							var realSrc = event && event.target && event.target.src;
 							error.message = 'Loading chunk ' + chunkId + ' failed.\n(' + errorType + ': ' + realSrc + ')';
 							error.name = 'ChunkLoadError';
 							error.type = errorType;
 							error.request = realSrc;
 							chunk[1](error);
 						}
 						installedChunks[chunkId] = undefined;
 					}
 				};
 				var timeout = setTimeout(function(){
 					onScriptComplete({ type: 'timeout', target: script });
 				}, 120000);
 				script.onerror = script.onload = onScriptComplete;
 				document.head.appendChild(script);
 			}
 		}
 		return Promise.all(promises);
 	};

 	// expose the modules object (__webpack_modules__)
 	__webpack_require__.m = modules;

 	// expose the module cache
 	__webpack_require__.c = installedModules;

 	// define getter function for harmony exports
 	__webpack_require__.d = function(exports, name, getter) {
 		if(!__webpack_require__.o(exports, name)) {
 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
 		}
 	};

 	// define __esModule on exports
 	__webpack_require__.r = function(exports) {
 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
 		}
 		Object.defineProperty(exports, '__esModule', { value: true });
 	};

 	// create a fake namespace object
 	// mode & 1: value is a module id, require it
 	// mode & 2: merge all properties of value into the ns
 	// mode & 4: return value when already ns object
 	// mode & 8|1: behave like require
 	__webpack_require__.t = function(value, mode) {
 		if(mode & 1) value = __webpack_require__(value);
 		if(mode & 8) return value;
 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
 		var ns = Object.create(null);
 		__webpack_require__.r(ns);
 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
 		return ns;
 	};

 	// getDefaultExport function for compatibility with non-harmony modules
 	__webpack_require__.n = function(module) {
 		var getter = module && module.__esModule ?
 			function getDefault() { return module['default']; } :
 			function getModuleExports() { return module; };
 		__webpack_require__.d(getter, 'a', getter);
 		return getter;
 	};

 	// Object.prototype.hasOwnProperty.call
 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };

 	// __webpack_public_path__
 	__webpack_require__.p = "/";

 	// on error function for async loading
 	__webpack_require__.oe = function(err) { console.error(err); throw err; };

 	var jsonpArray = window["webpackJsonp"] = window["webpackJsonp"] || [];
 	var oldJsonpFunction = jsonpArray.push.bind(jsonpArray);
 	jsonpArray.push = webpackJsonpCallback;
 	jsonpArray = jsonpArray.slice();
 	for(var i = 0; i < jsonpArray.length; i++) webpackJsonpCallback(jsonpArray[i]);
 	var parentJsonpFunction = oldJsonpFunction;


 	// run deferred modules from other chunks
 	checkDeferredModules();
